import * as api from "../../shared/api";
import * as biz_data_helper from "../../shared/biz_data_helper";

const content_type = "WrkCtrTable";

const create = function () {
  return {
    content_type: "muji",
    age: 29
  };
};
const descriptor = {};

const biz_data = new biz_data_helper.base_entity_helper(
  content_type,
  create,
  descriptor
);

const fields = {
  default: [
    {
      key: "id",
      label: "编号",
      sortable: true,
      type: "button",
      button: {
        type: "text"
      },
      thStyle: { width: "60px" }
    },
    { key: 'dataAreaId', label: '公司', sortable: true },
    { key: 'WrkCtrType', label: '类型', sortable: true },
    {
      key: 'WrkCtrId', label: '资源', sortable: true, type: "short",
      thStyle: {
        width: "12rem"
      }
    },
    {
      key: 'Name', label: '描述', sortable: true, type: "short",
      thStyle: {
        width: "12rem"
      }
    },
    { key: 'DW_ResourcegGroupId', label: '资源组', sortable: true },
    { key: 'SetupTime', label: '设置时间', sortable: true },
    { key: 'ProcessTime', label: '运行时间', sortable: true },
    { key: 'ProcessPerQty', label: '处理数量', sortable: true },
    { key: 'TranspTime', label: '运输时间', sortable: true },
    { key: 'PerWorkerPrice', label: '单位工价', sortable: true },
    { key: 'SetUpCategoryId', label: '设置类别', sortable: true },
    { key: 'ProcessCategoryId', label: '运行时间类别', sortable: true },
    { key: 'TEC_ProcessPerQty', label: 'SEI单位产能', sortable: true },
    { key: 'TEC_EquipPower', label: '设备功率', sortable: true },
    { key: 'SEI_ResourceID', label: 'SEI设备编码', sortable: true },
    { key: 'TEC_WrkCtrNum', label: '资源编号', sortable: true },
    { key: 'SEI_isUKPlant', label: 'UK车间', sortable: true },
    { key: 'SEI_isSkipRouteQty', label: '忽略报工数量', sortable: true },
    { key: 'SEI_doNotCreateJob', label: '不创建作业', sortable: true },
    { key: 'SEI_UPPH', label: 'UPPH', sortable: true },
    { key: 'SEI_IsRealtimeReport', label: '是否实时报工', sortable: true },
    { key: 'SEI_Workshop', label: '工厂', sortable: true },
    { key: 'SEI_WorkerCount1', label: '人数', sortable: true },
    { key: "RecId", label: "RecId", sortable: true },
  ]
};

const dataForm = {};

///前端验证
const rules = {};
const methods = {
  ///get
  async getData(_params) {
    let result = await biz_data
      .selectAction({
        params: _params,
        fields: _.map(fields.default, "key")
      })
      .run();

    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data;
    } else {
      return null;
    }
  },
  async saveData(params) {
    let _actions = [];
    for (var k in params) {
      if (k == "add") {
        _actions.push(
          biz_data.insertAction({
            params: params[k],
            fields: _.map(fields.default, "key")
          }).action({})
        );
      }
      else if (k == "edit") {
        _actions.push(
          biz_data.updateAction({
            params: params[k],
            fields: _.map(fields.default, "key")
          }).action({})
        );
      }
      else if (k == "delete") {
        _actions.push(
          biz_data.deleteAction({
            params: params[k],
            fields: _.map(fields.default, "key")
          }).action({})
        );
      }
    }
    let result = await api.query_batch({
      actions: _actions
    });
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0 &&
      result.data.BatchResult.Actions[0].Result.Data.length > 0
    ) {
      return result.data.BatchResult.Actions[0].Result.Data[0];
    } else {
      return null;
    }
  }
};
export { biz_data, dataForm, fields, methods, rules };

